export default function formatDate(inputDate) {
  // Format string date into MM/dd/yyyy
  const date = new Date(inputDate)
  if (!isNaN(date.getTime())) {
    // Months use 0 index.
    return date.getMonth() + 1 + '/' + (date.getDate() + 1) + '/' + date.getFullYear()
  }
  return null
}
